import PropTypes from 'prop-types';
import React from 'react';

import MediaCarousel from 'dpl/components/MediaCarousel';
import SmartImage from 'dpl/components/SmartImage';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_LG = isLessThanBreakpoint('lg');

export default function BreedHealthTestBreeders({ breederProfilesData }) {
  return (
    <div className="BreedHealthTestBreeders">
      <div className="row flex-nowrap overflow-auto right-bleeding-row">
        {
          // TODO: temp until we create a separate, mobile BreederProfileItem
          // component that doesn't rely on media queries
          breederProfilesData.value.data.map((profile, idx) => (
            <div key={idx} className="col-9 col-lg-auto">
              <a
                href={profile.url}
                className="db w-100 overflow-visible hide-child"
              >
                <div className="BreederProfileItem__image bg-light-gray br1 mb3">
                  <MediaCarousel
                    files={profile.result_photos}
                    smartImageProps={{
                      Tag: 'div',
                      className: 'bg-top cover w-100 mw-100 br1',
                      crop: true,
                      loadingClass: 'bg-light-gray'
                    }}
                    dimensions={{
                      height: IS_LT_LG ? '167px' : '250px',
                      width: IS_LT_LG ? '250px' : '364px'
                    }}
                    arrowClassName="white f6 child"
                    bulletsContainerClassName="pv0"
                    showScrims
                    maxBulletsPadding={2}
                    scrimClassName="child"
                  />
                </div>
                <div className="flex align-items-center">
                  <div className="flex-auto">
                    <p className="fw-medium truncate f4-lg">{profile.name}</p>
                    {profile.facility_location && (
                      <span>{profile.facility_location}</span>
                    )}
                  </div>
                  <div className="d-none d-lg-block">
                    <SmartImage
                      Tag="div"
                      alt={profile.name}
                      className="br-100 cover"
                      height="56px"
                      lazy
                      loadingClass="bg-light-gray"
                      src={profile.profile_photo_url}
                      width="56px"
                    />
                  </div>
                </div>
              </a>
            </div>
          ))
        }
      </div>
    </div>
  );
}

BreedHealthTestBreeders.propTypes = {
  breederProfilesData: PropTypes.shape({
    value: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          facility_location: PropTypes.string
        })
      ).isRequired
    }).isRequired
  }).isRequired
};
